import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { TooltipService } from 'src/app/components/shared/layout/shared/tooltip.service';

@Directive({
  selector: '[appToolTip]',
})
export class ToolTipDirective implements OnDestroy {
  @Input('appToolTip') tooltipContent: string = '';
  @Input() tooltipPosition: 'top' | 'bottom' | 'auto' = 'auto';
  @Input() tooltipDelay = 300;
  private showTimer: any;

  constructor(
    private elRef: ElementRef,
    private tooltipService: TooltipService
  ) {
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.tooltipContent?.trim()) return;

    this.showTimer = setTimeout(() => {
      this.tooltipService.showTooltip(
        this.tooltipContent,
        this.elRef.nativeElement,
        this.tooltipPosition
      );
    }, this.tooltipDelay);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    clearTimeout(this.showTimer);
    this.tooltipService.hideTooltip(100);
  }

  ngOnDestroy() {
    clearTimeout(this.showTimer);
    this.tooltipService.hideTooltip();
  }
}
